import { addWidgetToLayout } from "api/Dashboard";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useAddWidgetToLayout = () => {
    const queryClient = useQueryClient();

    return useMutation(addWidgetToLayout, {
        onSuccess: () => {
            toast.success('Added Successfully')
            queryClient.invalidateQueries('dashboardLayout');

        },
        onError: (error: any) => {
            toast.error(error.response.data.error || 'Something went wrong')
        }
    });
};
